import {Injectable} from '@angular/core';
import {MsisdnsResponse, SubjectCategoriesResponse} from '@npck/af-frontend-api';
import {RouterService} from '@npck/libs/commons';
import dayjs from 'dayjs';
import {SearchPlaceholderContext} from '../components/full-table/filter/filter.component';
import {initialTableEvent, TableEvent} from '../components/full-table/full-table.component';
import {SubjectsTab, SubjectTabInfo} from '../pages/subjects/subjects.component';
import {Path} from '../path';

@Injectable({providedIn: 'root'})
export class SubjectFilterHolderService {
    private tabs: SubjectsTab[] = [
        'tabSubjectEventsAndAttempts',
        'tabLoans',
        'tabCompromisedPaymentInstruments',
        'tabOtherIllegalIncidentsSubjects',
        'tabSuspiciousNumbers',
    ];

    private tabTableHolder = this.initialState();

    constructor(
        private routerService: RouterService,
    ) {
        this.routerService.navigationEnd()
            .subscribe(event => {
                if (!event.url.includes(Path.SUBJECTS)) {
                    this.clear();
                }
            });
    }

    storeTableState(tab: SubjectsTab, tableEvent: TableEvent): SubjectTabInfo {
        this.tabTableHolder[tab] = {
            ...this.tabTableHolder[tab],
            tableEvent: tableEvent,
        };
        return this.tabTableHolder[tab];
    }

    storeResponse(tab: SubjectsTab, response: SubjectCategoriesResponse | MsisdnsResponse): void {
        this.tabTableHolder[tab] = {...this.tabTableHolder[tab], response, cachedTime: dayjs()};
    }

    getState(tab: SubjectsTab): SubjectTabInfo {
        return this.tabTableHolder[tab];
    }

    clear(): void {
        this.tabTableHolder = this.initialState();
    }

    getPlaceholderContext(tab: SubjectsTab): SearchPlaceholderContext {
        switch (tab) {
            case 'tabSubjectEventsAndAttempts':
            case 'tabCompromisedPaymentInstruments':
            case 'tabOtherIllegalIncidentsSubjects':
                return 'list';
            case 'tabSuspiciousNumbers':
                return 'msisdn';
            default:
                return null;
        }
    }

    private initialState(): Record<SubjectsTab, SubjectTabInfo> {
        return this.tabs.reduce((acc, item) => {
            if (!acc[item]) {
                acc[item] = <SubjectTabInfo>{
                    tableEvent: {
                        ...initialTableEvent,
                        filter: {},
                    },
                    placeholderContext: this.getPlaceholderContext(item),
                };
            }
            return acc;
        }, {} as Record<SubjectsTab, SubjectTabInfo>);
    }
}
